/* =====================================================
   Adele Chérie — Header 2026 interactions
   Sticky on scroll · Mobile drawer · Search overlay
   ===================================================== */

(function() {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__acHeaderInit) return;
  window.__acHeaderInit = true;

  function init() {
    var header = document.getElementById('ac-header');
    if (!header) return;
    var sticky = header.getAttribute('data-sticky') === 'true';

    // ===== Scroll: aggiunge .is-scrolled =====
    if (sticky) {
      var lastY = 0;
      var ticking = false;
      function onScroll() {
        var y = window.pageYOffset;
        header.classList.toggle('is-scrolled', y > 24);
        lastY = y;
        ticking = false;
      }
      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      }, { passive: true });
      onScroll();
    }

    // ===== Mobile drawer =====
    var drawer = document.getElementById('ac-mobile-drawer');
    var burger = document.querySelector('[data-ac-burger]');
    var closes = document.querySelectorAll('[data-ac-drawer-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (burger) {
      burger.addEventListener('click', function() {
        var open = drawer.getAttribute('aria-hidden') === 'false';
        if (open) closeDrawer(); else openDrawer();
      });
    }
    closes.forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });

    // ESC chiude drawer
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
        closeSearch();
      }
    });

    // Search overlay handled by ac-search.js
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
